<template>
  <div class="options-panel">
    <div class="options-panel_cnt">
      <div class="options-mobile-head s-title">
        <div v-if="panelType === 1">
          <div class="options-mobile-head_title"
               v-on:click="toggleMobmenu()">
            {{mobUserMenu[user.menu]}}
          </div>
          <div class="options-mobile-head_list"
               v-bind:class="{ active : mobMenuStatus }">
            <div class="options-mobile-head_item"
                 v-for="(item, idx) in mobUserMenu"
                 v-on:click="changeMobUserMenu(idx)">
              {{item}}
            </div>
          </div>
        </div>
        <div v-if="panelType === 2">
          <div class="options-mobile-head_title"
               v-on:click="toggleMobmenu()">
            {{mobSettMenu[settingsItem]}}
          </div>
          <div class="options-mobile-head_list"
               v-bind:class="{ active : mobMenuStatus }">
            <div class="options-mobile-head_item"
                 v-for="(item, idx) in mobSettMenu"
                 v-if="idx !== 3"
                 v-on:click="changeMobSettMenu(idx)">
              {{item}}
            </div>
          </div>
        </div>
      </div>
      <div class="close-option" v-on:click="closeOptionPanel">
      </div>
      <UserSettings v-if="panelType === 1">
      </UserSettings>
      <Settings v-if="panelType === 2 || panelType === 5">
      </Settings>
      <EventsFilter v-if="panelType === 3">
      </EventsFilter>
      <Commands v-if="panelType === 4">
      </Commands>
    </div>
  </div>
</template>

<script>
  import Commands       from "./OptionPanel/Commands"
  import Settings       from "./OptionPanel/Settings"
  import UserSettings   from "./OptionPanel/UserSettings"
  import EventsFilter   from "./OptionPanel/EventsFilter"

  export default {
    data : function () {
      return{
        mobMenuStatus : false,
        mobUserMenu : [
          'Профиль пользователя',
          'Менеджер автопарка',
          'Настройки оповещения о ТО',
          'Сервисные отчеты'
        ],
        mobSettMenu : [
          'Автозапуск двигателя',
          'Уведомления от охранной системы',
          'Общие настройки',
          'Автомобиль на карте',
          'Параметры охранной системы',
          'Датчики',
          'Общий доступ к автомобилю',
        ]
      }
    },
    methods : {
      toggleMobmenu : function () {
        this.mobMenuStatus = !this.mobMenuStatus
      },
      changeMobUserMenu : function ( index ) {
        this.$store.dispatch('userMenu', index );
        this.mobMenuStatus = !this.mobMenuStatus
      },
      changeMobSettMenu : function ( index ) {
        this.$store.dispatch('settingPanel', index);
        this.mobMenuStatus = !this.mobMenuStatus
      },
      closeOptionPanel : function () {
        if( this.panelType === 1 || this.panelType === 2 ){
          this.$store.dispatch('optionPanel', 0);
          this.$store.dispatch('optionPanelType', 0);
          this.$store.dispatch('controlPanel', 1 );
          this.$store.dispatch('controlPanelMenu', 1 );
        }else{
          this.$store.dispatch('optionPanel', 0);
        }
      }
    },
    computed : {
      user : function(){
        return this.$store.state.user
      },
      settingsItem : function () {
        return this.$store.state.panels.settings
      },
      panelType : function () {
        return this.$store.state.panels.option.type
      }
    },
    components : {
      Commands,
      Settings,
      UserSettings,
      EventsFilter
    }
  }
</script>